import { render, staticRenderFns } from "./SampleProfileLayout.vue?vue&type=template&id=19ed6755"
import script from "./SampleProfileLayout.vue?vue&type=script&lang=js"
export * from "./SampleProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./SampleProfileLayout.vue?vue&type=style&index=0&id=19ed6755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports